import { MostSearchedResult, MostSearchedResultType, SearchType } from '@/types/most-search-type';
import { getMostSearches } from '@/utils/consts/most-searches-procedures/most-searches-procedures';
import { mostSearchesVaccines } from '@/utils/consts/most-searches-procedures/most-searches-vaccines.consts';
import { CheckboxProcedure } from '@/app/(main)/_components/search-modal/_components/checkbox-procedure.component';
import { LaboratoryProcedureLoading } from '@/app/(main)/_components/search-modal/_components/loadings/laboratory-procedure-loading.component';
import { SearchResult, SelectedProcedures } from '@/app/(main)/_components/search-modal/search-modal.types';

export interface SelectMoreResultsProps {
  isLoading?: boolean;
  searchResults?: SearchResult[];
  searchType: SearchType;
  isChecked: (procedure: MostSearchedResult | SearchResult | SelectedProcedures) => boolean;
  handleSelectProcedure: (procedure: MostSearchedResult | SearchResult | SelectedProcedures) => void;
}

export function SelectMoreResults({
  isLoading,
  searchResults,
  searchType,
  handleSelectProcedure,
  isChecked,
}: SelectMoreResultsProps) {
  const hasSearchResults = (searchResults?.length ?? 0) > 0;

  const mostSearched: MostSearchedResultType
    = searchType === SearchType.VACCINE
      ? mostSearchesVaccines
      : getMostSearches().find((item) => item.type === searchType) ?? ({} as MostSearchedResultType);

  if (isLoading) {
    return <LaboratoryProcedureLoading />;
  }

  if (hasSearchResults) {
    return (
      <>
        {searchResults?.map((procedure) => (
          <CheckboxProcedure
            key={procedure.id || procedure.code}
            procedure={procedure}
            handleSelectProcedure={handleSelectProcedure}
            isChecked={isChecked}
          />
        ))}
      </>
    );
  }

  return (
    <>
      {mostSearched?.procedures.map((procedure) => (
        <CheckboxProcedure
          key={procedure.id}
          procedure={procedure}
          handleSelectProcedure={handleSelectProcedure}
          isChecked={isChecked}
        />
      ))}
    </>
  );
}
